package com.patronat.top.core.base

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.network.NetworkResult
import com.patronat.top.error.AppErrorCode
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.flow.*
import kotlinx.coroutines.launch

abstract class BaseViewModel<State : ViewState, Event : ViewEvent, Effect : ViewSideEffect>(
    initialState: State
) : ViewModel() {

    private val _viewState = MutableStateFlow(initialState)
    val viewState: StateFlow<State> = _viewState.asStateFlow()

    protected fun updateState(block: (State) -> State) {
        _viewState.update(block)
    }

    protected val currentState: State
        get() = viewState.value

    abstract fun onEvent(event: Event)

    private val _effect = Channel<Effect>(Channel.BUFFERED)
    val effect: Flow<Effect> = _effect.receiveAsFlow()

    protected fun sendEffect(effect: Effect) {
        viewModelScope.launch {
            _effect.send(effect)
        }
    }

    protected fun <T> launchNetwork(
        onLoading: ((Boolean) -> Unit)? = null,
        onError: ((AppErrorCode, String?) -> Unit)? = null,
        request: suspend () -> DomainResult<T>,
        onSuccess: (T) -> Unit
    ) {
        viewModelScope.launch {
            onLoading?.invoke(true)

            when (val result = request()) {
                is DomainResult.Success -> {
                    onLoading?.invoke(false)
                    onSuccess(result.data)
                }
                is DomainResult.Error -> {
                    onLoading?.invoke(false)
                    if (onError != null) {
                        onError(result.type, result.message)
                    } else {
                        println("BaseViewModel Error: ${result.type} - ${result.message}")
                    }
                }
            }
        }
    }

}